import httpRequest from "commons/request";
import { UserResponse } from "commons/types";

export async function getUserProfile() {
    const apiHost = process.env.REACT_APP_SPARK_API_HOST;
    const URL = `${apiHost}/api/user/me`;
    const response = await httpRequest<UserResponse>(URL, { method: "GET" });
    return response
}